import { RoleModuleConfig } from './types';
import { DXAScoringFormSlice } from '@restore/DXAScoringForm/DXAScoringForm.slice';
import { measurementsSlice } from '@restore/measurements/measurements.slice';
import { DICOMViewerSlice } from '@restore/DICOMViewer/DICOMViewer.slice';
import { readerTaskSlice } from '@restore/readerTask/readerTask.slice';
import { readerCacheSlice } from '@restore/readerCache/readerCache.slice';
import { ReaderTasksListSlice } from '@restore/ReaderTasks/ReaderTasksList.slice';
import { readerSubTaskSlice } from '@restore/readerSubTask/readerSubTask.slice';
import { readerTaskOrchestrationSlice } from 'src/store-redux/readerTaskOrchestration/readerTaskOrchestration.slice';
import { clinicalTrialInventorySlice } from '@restore/clinicalTrialInventory/clinicalTrialInventory.slice';

import { DXAScoringFormSaga } from '@restore/DXAScoringForm/DXAScoringForm.saga';
import { measurementsSaga } from '@restore/measurements/measurements.saga';
import { DICOMViewerSaga } from '@restore/DICOMViewer/DICOMViewer.saga';
import { readerTaskSaga } from '@restore/readerTask/readerTask.saga';
import { readerCacheInvalidationSaga } from '@restore/readerCache/readerCache.saga';
import { ReaderTasksListSaga } from '@restore/ReaderTasks/ReaderTasks.saga';
import { readerSubTaskSaga } from '@restore/readerSubTask/readerSubTask.saga';
import { readerTaskOrchestrationSaga } from 'src/store-redux/readerTaskOrchestration/readerTaskOrchestration.saga';
import { clinicalTrialInventorySaga } from '@restore/clinicalTrialInventory/clinicalTrialInventory.saga';

import { formManagementSaga } from 'src/store-redux/readerViewerSession/formManagement/formManagement.saga';
import { watchFirstVisitSwitchSaga } from 'src/store-redux/readerTaskOrchestration/workers/lazyPrefetchSubtasksWorker';
import { tabCoordinationSlice } from '../readerViewerSession/tabCoordination/tabCoordination.slice';
import { formManagementSlice } from '../readerViewerSession/formManagement/formManagement.slice';
import { tabCoordinationSaga } from '../readerViewerSession/tabCoordination/tabCoordination.saga';
import { segmentationSlice } from '@restore/segmentation/segmentation.slice';
import { segmentationSaga } from '@restore/segmentation/segmentation.saga';

export const readerModules: RoleModuleConfig = {
  slices: [
    clinicalTrialInventorySlice,
    DXAScoringFormSlice,
    measurementsSlice,
    DICOMViewerSlice,
    readerTaskSlice,
    readerCacheSlice,
    ReaderTasksListSlice,
    readerSubTaskSlice,
    readerTaskOrchestrationSlice,
    tabCoordinationSlice,
    formManagementSlice,
    segmentationSlice
  ],
  sagas: {
    DXAScoringFormSaga,
    measurementsSaga,
    DICOMViewerSaga,
    readerTaskSaga,
    readerCacheInvalidationSaga,
    watchFirstVisitSwitchSaga,
    ReaderTasksListSaga,
    readerSubTaskSaga,
    readerViewerPageSaga: readerTaskOrchestrationSaga,
    clinicalTrialInventorySaga,
    tabCoordinationSaga,
    formManagementSaga,
    segmentationSaga
  },
};
